module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("William and the Pirates of Fruxiclay")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-as-silent-as-the-grave"
    }
  }, [_vm._v("Chapter 1: As Silent as the Grave")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2-time-for-making-amends"
    }
  }, [_vm._v("Chapter 2: Time for Making Amends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3-selfless-magic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Selfless Magic")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4-the-pirates-from-fruxiclay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Pirates from\n          Fruxiclay")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5-the-sooly-worms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Sooly Worms")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6-smell-the-coffee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Smell the Coffee")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-the-invisible-ball",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Invisible Ball")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-out-of-the-frying-pan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Out of the Frying Pan…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-into-the-fire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Into the Fire…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-in-dire-straits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: In Dire Straits")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-saved-by-the-bell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Saved by the Bell")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12-a-pleasant-surprise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: A Pleasant Surprise")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13-dont-beat-about-the-bush",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Don’t Beat About the\n          Bush…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14-all-that-ends-well",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: All That Ends Well…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15-problem-solving",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Problem Solving")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-16-a-testing-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: A Testing Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-17-home-again-once-more",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Home Again Once More?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-18-the-grass-is-not-greener-on-the-other-side",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The\n          Grass Is Not Greener on the Other Side")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-19-trying-to-get-back-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Trying to Get Back\n          Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-20-still-trying-to-go-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Still Trying to Go\n          Home…")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-21-where-is-the-milky-way",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Where Is the Milky\n          Way?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-22-home-at-last",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Home at Last")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0